import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class InstantCheckupHelper {
  getCheckupsByType(checkups: Array<object>, type: string): Array<object> {
    if (!checkups) {
      return [];
    }
    return checkups.filter((checkup: any): boolean => checkup.type === type);
  }
}
